__turbopack_context__.v({
  "icon": "IconSystemLink-module-scss-module__6kSB5W__icon",
  "link": "IconSystemLink-module-scss-module__6kSB5W__link",
  "m": "IconSystemLink-module-scss-module__6kSB5W__m",
  "primary": "IconSystemLink-module-scss-module__6kSB5W__primary",
  "quartiary": "IconSystemLink-module-scss-module__6kSB5W__quartiary",
  "s": "IconSystemLink-module-scss-module__6kSB5W__s",
  "secondary": "IconSystemLink-module-scss-module__6kSB5W__secondary",
  "tertiary": "IconSystemLink-module-scss-module__6kSB5W__tertiary",
  "xs": "IconSystemLink-module-scss-module__6kSB5W__xs",
});
